import type { WizardFormValues } from '@/lib/wizard-draft'

/** Mirrors client-service _FIELD_LIMITS (DB column widths). Keys are form field names. */
export const FIELD_MAX_LENGTH: Partial<Record<keyof WizardFormValues, number>> = {
  full_name: 100,
  birth_place: 100,
  spouse_name: 100,
  mother_maiden_name: 100,
  identity_number: 16,
  npwp_number: 20,
  address_street: 500,
  home_postal_code: 5,
  home_phone: 20,
  home_fax: 20,
  home_ownership_notes: 500,
  account_purpose_notes: 500,
  occupation_other: 100,
  company_name: 255,
  industry_field: 100,
  position: 100,
  office_address: 255,
  office_postal_code: 5,
  office_phone: 20,
  office_fax: 20,
  home_location: 500,
  other_assets: 255,
  bank_branch: 100,
  account_number: 16,
  account_holder: 100,
  bank_phone: 20,
  bank_address: 500,
  bank_city: 100,
  bank_province: 100,
  bank_swift: 11,
  bank_iban: 34,
  emergency_name: 100,
  emergency_address: 500,
  emergency_postal_code: 5,
  emergency_phone: 20,
  emergency_relation: 50,
}

/** Free text: also rejects < > and control characters (tab and newlines allowed). */
export const FREE_TEXT_FIELDS: ReadonlySet<string> = new Set([
  'address_street',
  'home_ownership_notes',
  'account_purpose_notes',
  'occupation_other',
  'company_name',
  'industry_field',
  'position',
  'office_address',
  'home_location',
  'other_assets',
  'bank_branch',
  'bank_address',
  'bank_city',
  'bank_province',
  'emergency_address',
  'emergency_relation',
])
